const constants = {
    monneyGooglePlayUrl: 'https://play.google.com/store/apps/details?id=com.fintech.smart.lenket',
    monneyAppStoreUrl: 'https://apps.apple.com/kr/app/apple-store/id1447928072',
    papaynosGooglePlayUrl: 'https://play.google.com/store/apps/details?id=com.papynos.app',
    papaynosAppStoreUrl: 'https://apps.apple.com/kr/app/파피노스/id6733221481'
};

export default constants;